import { useEffect, useReducer } from 'react'
import { Lesson } from 'types'
import { buildSlides } from './buildSlides'
import { Slide } from './types'

/* TODO: Similar to state management in lesson-builder but eh */
type State = {
  lessonPdf: string | null
  slides: Slide[]
  currentSlide: number
}

type Action =
  | { type: 'INIT'; payload: Lesson }
  | { type: 'SET_CURRENT_SLIDE'; slideNum: number }

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'INIT': {
      const { slides } = buildSlides(action.payload.numSlides, action.payload.questionSlides)
      return {
        lessonPdf: action.payload.lessonPdf || null,
        slides,
        currentSlide: 0,
      }
    }
    case 'SET_CURRENT_SLIDE':
      return { ...state, currentSlide: action.slideNum }
    default:
      return state
  }
}

export const usePresenterSlides = ({ lessonDetails }: { lessonDetails: Lesson | null }) => {
  const [state, dispatch] = useReducer(reducer, {
    lessonPdf: null,
    slides: [],
    currentSlide: 0,
  })

  useEffect(() => {
    if (lessonDetails) {
      dispatch({ type: 'INIT', payload: lessonDetails })
    }
  }, [lessonDetails])

  const setCurrentSlide = (slideNum: number) => dispatch({ type: 'SET_CURRENT_SLIDE', slideNum })

  return {
    lessonPdf: state.lessonPdf,
    slides: state.slides,
    currentSlide: state.currentSlide,
    setCurrentSlide,
  }
}


